<div class="grid-container full-height full v-pad">
  <div class="user-form-max-width">
    <h3>Administrative Data Correction</h3>
    <div class="grid-x grid-margin-x">
      <div class="cell small-8">
        <label>
          External Request Application Id (if applicable):
          <input type="text" [(ngModel)]="existingDataCorrectionInstance.externalRequestApplicationId"
            [disabled]="existingDataCorrectionInstance.id !==''"/>
          </label>
        </div>
        <div class="cell small-8">
          <label>
            Data Type (Only types with a defined review group will appear here):
            <select (change)="setCollectionType($event)" [(ngModel)]="existingDataCorrectionInstance.entityId"
              [disabled]="existingDataCorrectionInstance.id !==''">
              <option [value]=""></option>
              @for (entity of entityTypes; track entity) {
                <option [value]="entity.id">
                  {{ entity.entityName }}
                </option>
              }
            </select>
          </label>
        </div>
      </div>
      @if (entity) {
        <div>
          <div class="user-form-max-width">
            <h4>{{ entity.entityName }} Data Correction</h4>
            <div class="grid-x grid-margin-x">
              <div class="cell small-8">
                <label>
                  *Unique Item Identifier:
                  <input type="text" [(ngModel)]="existingDataCorrectionInstance.objectId"
                    [disabled]="existingDataCorrectionInstance.id !==''"/>
                  </label>
                </div>
                @if (existingDataCorrectionInstance.id ==='') {
                  <div class="cell small-8">
                    <button class="button hollow minor-margin-right" [disabled]="existingDataCorrectionInstance.objectId ===''" (click)="getData()">Get Data</button>
                  </div>
                }
              </div>
            </div>
          </div>
        }
      </div>
      <div><data-correction [adHocReviewWorkOrderId]="workOrderId" [objectEntity] = "entity" [correctionDataInstanceEmitter] = "existingDataCorrectionInstanceEmitter" [dataModel] = "dataModel" [isInReviewMode] ="isInReviewMode"></data-correction></div>
    </div>
